import React, { useEffect, useState } from 'react'
import { useQuery, useMutation } from '@apollo/client';
import { getBookletByReviewTokenQuery } from '../../queries/booklet';
import LogoWhite from '../../img/sa-enkelt-logo-white.svg';
import CityLogo from '../../img/city-logo-2.svg';
import { useNavigationContext } from '../../context/NavigationContext';
import { getCompanyTypesQuery } from '../../queries/company';
import CompanyReviewCoupons from './CompanyReviewCoupons';
// import CompanyReviewBooklet from './CompanyReviewBooklet';
import { companyReviewByTokenQuery, updateBookletCompanyReviewWithTokenMutation } from '../../queries/bookletCompanyReview';
import { Button } from '../../common/index';
import { IoChevronDownSharp } from 'react-icons/io5';
import { motion, AnimatePresence } from 'framer-motion';

const { REACT_APP_BRAND } = process.env;
function CompanyReview(props) {
  const { token } = props.match.params;
  const { setNavigationActivated } = useNavigationContext();
  const { data: companyTypesData } = useQuery(getCompanyTypesQuery);
  const { data: companyReviewData, loading: companyReviewLoading, error: companyReviewError, refetch: refetchReview } = useQuery(companyReviewByTokenQuery, { variables: { token: token } });
  const { data: bookletData, loading: bookletLoading, error: bookletError } = useQuery(getBookletByReviewTokenQuery, { variables: { token: token } });
  const [approveReview] = useMutation(updateBookletCompanyReviewWithTokenMutation);

  const [reviewOption, setReviewOption] = useState(null); // 'comment' or 'approve'
  const [message, setMessage] = useState('');
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);

  useEffect(() => {
    setNavigationActivated(false);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      // Hide scroll indicator after scrolling down
      if (window.scrollY > 200) {
        setShowScrollIndicator(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (companyReviewLoading || bookletLoading) return null;
  if (companyReviewError || bookletError) {
    console.log('Error', companyReviewError, bookletError);
  }

  const handleMessageChange = (event) => {
    setMessage(event.target.value)
  }
  const handleSubmit = () => {
    if (reviewOption === 'comment') {
      if (!message.trim()) {
        return;
      }
      approveReview({
        variables: {
          token: token,
          comment: message
        }
      }).then(() => {
        refetchReview();
        setReviewOption(null);
        setMessage('');
      }).catch(error => {
        console.error('Error sending comment: ', error)
      })
    } else if (reviewOption === 'approve') {
      approveReview({
        variables: {
          token: token,
          approvedDate: new Date()
        }
      }).then(() => {
        refetchReview();
        setReviewOption(null);
      }).catch(error => {
        console.error('Error approving review: ', error)
      })
    }
  }

  const booklet = bookletData?.bookletByReviewToken;
  const bookletColor = booklet?.colorLeft || booklet?.colorRight || '#E0E0E0';

  return (
    <div id="company-review" className='flex flex-col items-center'>
      <header className={`flex flex-col justify-center items-center ${REACT_APP_BRAND === 'SAENKELT' ? 'saenkelt' : ''}`}>
        <img src={REACT_APP_BRAND === 'CITY' ? CityLogo : LogoWhite} alt={REACT_APP_BRAND === 'CITY' ? 'City Logo' : 'Så Enkelt Logo'} />
      </header>
      <AnimatePresence>
        {showScrollIndicator && !companyReviewError && !bookletError &&
          companyReviewData?.bookletCompanyReviewByToken?.isActive &&
          !companyReviewData?.bookletCompanyReviewByToken?.approvedDate &&
          !companyReviewData?.bookletCompanyReviewByToken?.comment && (
            <motion.div
              className="company-review-scroll-indicator"
              style={{ backgroundColor: bookletColor }}
              initial={{ opacity: 1 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2, ease: 'easeOut' }}
            >
              <IoChevronDownSharp size={36} color="#fff" />
            </motion.div>
          )}
      </AnimatePresence>
      {!companyReviewError && !bookletError
        ? <>
          {!companyReviewData?.bookletCompanyReviewByToken?.isActive ?
            <div className='relative company-review-content flex flex-col items-center'>
              <h2>Granska och godkänn dina erbjudanden</h2>
              <p>Denna granskningslänk är inte längre giltig. Vänligen kontakta <a href="https://saenkelt.se/kundtjanst/">kundtjänst</a> om ni ser ett behov av att granska eller justera era kuponger.</p>
            </div>
            :
            companyReviewData?.bookletCompanyReviewByToken?.approvedDate ?
              <div className='relative company-review-content flex flex-col items-center'>
                <h2>Tack för din granskning!</h2>
                <p>Du har godkänt innehållet och ditt/dina erbjudanden kommer snart att synas i häftet.</p>
                <p className='m-0'>Du är nu klar och kan stänga fönstret.</p>
              </div>
              : companyReviewData?.bookletCompanyReviewByToken?.comment ?
                <div className='relative company-review-content flex flex-col items-center'>
                  <h2>Tack för din kommentar!</h2>
                  <p>När vi tagit emot den återkommer vi med en ny länk för granskning om det behövs.</p>
                  <p className='m-0'>Vid mindre rättningar åtgärdar vi och godkänner erbjudandet direkt.</p>
                </div>
                :
                <>
                  <div className='relative company-review-content flex flex-col items-center'>
                    <h2>Granska och godkänn dina erbjudanden</h2>
                    <p className='text-center'>Ge feedback eller godkänn längst ned.</p>
                    <div className="company-review-apps flex">
                      {/* <CompanyReviewBooklet
                        booklet={bookletData?.bookletByReviewToken}
                        companyReviewData={companyReviewData}
                        companyTypesData={companyTypesData}
                      /> */}
                      <CompanyReviewCoupons
                        companyReviewData={companyReviewData}
                        companyTypesData={companyTypesData}
                        booklet={bookletData?.bookletByReviewToken}
                      />
                    </div>
                  </div>
                  <div className="company-review-confirm flex flex-col items-center justify-center">
                    <h2 className='text-center'>Skicka in granskning</h2>
                    <p className='text-center m-0'>Välj om du vill lämna en kommentar eller godkänn innehållet direkt.</p>
                    <div className="flex flex-col gap-2 my" style={{ maxWidth: '350px', width: '100%' }}>
                      <label className="flex items-center gap-2 c-pointer">
                        <input
                          type="radio"
                          name="reviewOption"
                          value="comment"
                          checked={reviewOption === 'comment'}
                          onChange={(e) => setReviewOption(e.target.value)}
                        />
                        <span>Lägg till kommentar</span>
                      </label>
                      <label className="flex items-center gap-2 c-pointer">
                        <input
                          type="radio"
                          name="reviewOption"
                          value="approve"
                          checked={reviewOption === 'approve'}
                          onChange={(e) => setReviewOption(e.target.value)}
                        />
                        <span>Godkänn utan kommentar</span>
                      </label>
                      {reviewOption === 'comment' && (
                        <textarea
                          className="comment-box"
                          placeholder="Beskriv vad du önskar justera..."
                          value={message}
                          onChange={handleMessageChange}
                        />
                      )}
                      {reviewOption === 'approve' && (
                        <p>Härligt! Klicka på Skicka när du är redo att slutföra granskningen.</p>
                      )}

                      <Button
                        className="primary lg"
                        onClick={handleSubmit}
                        disabled={!reviewOption || (reviewOption === 'comment' && !message.trim())}
                      >
                        Skicka
                      </Button>
                    </div>
                  </div>
                </>
          }
        </>
        : <div className='relative company-review-content flex flex-col items-center'>
          <h2>Något gick fel</h2>
          <p>Vi kunde inte hitta någon granskning med den angivna länken.</p>
        </div>
      }
    </div>
  )
}

export default CompanyReview
